import { FieldNumberOutlined } from '@ant-design/icons';
import { Form, Input } from "antd";
import { PlatformDomain } from "../../apis/mgmt/api";
import { DataForm } from "../common/DataForm";
import { DataViewProps } from "../common/DataView";
import { PlatformFormItem, PlatformSelect } from '../platform/PlatformSelect';
import { DomainFormItem, DomainSelect } from '../domain/DomainSelect';


export const PlatformDomainForm = function (
    props: DataViewProps<PlatformDomain>
) {
    
    return (
        <DataForm {...props}>

            {/* id */}
            <Form.Item
                className="input"
                name="id"
            >
                <Input prefix={<FieldNumberOutlined className="site-form-item-icon" />} placeholder="ID" disabled={true} />
            </Form.Item>

            {/* domain */}
            <DomainFormItem
                name={"domain"}
                rules={[{ required: true, message: '¡Please select the domain!' }]}
            >
                <DomainSelect />
            </DomainFormItem>

            {/* platform */}
            <PlatformFormItem
                name="platform"
                rules={[{ required: true, message: '¡Please select the platform!' }]}
            >
                <PlatformSelect />
            </PlatformFormItem>

            <Form.Item
                className="input"
                name="slug"
            >
                <Input prefix={<FieldNumberOutlined className="site-form-item-icon" />} placeholder="Slug" />
            </Form.Item>
            
        </DataForm>
    );

};
